import { Grid } from "@mui/material";
import AccessionBarCodes from "./AccessionBarCodes";
import MemberBarCodes from "./MemberBarCodes";

const BarCodes = () => {
  return (
    <>
      <Grid container direction={"column"} gap={2} spacing={1}>
        <Grid item>
          <AccessionBarCodes />
        </Grid>
        <Grid item>
          <MemberBarCodes />
        </Grid>
      </Grid>
    </>
  );
};
export default BarCodes;
